import { makeStyles, Theme, createStyles, Box, BoxProps, Typography } from "@material-ui/core";
import EmptyState from "./emptyState";

export type StatisticsProps = {} & BoxProps;

export const Statistics = ({ ...props }: StatisticsProps) => {
  const classes = useStyles();

  return (
    <Box {...props} className={classes.root}>
      <Typography className={classes.header}>Statistics</Typography>
      <Box className={classes.box}>
        <EmptyState />
        <Typography className={classes.title}>You don’t have any statistics yet.</Typography>
        <Typography className={classes.subtitle}>
          Stay connected with Fuzebox. Control centre, instant notifications and real-time reporting
          on your full feature dash.
        </Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    header: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "29px",
      color: theme.palette.dark.main,
      paddingBottom: theme.spacing(3),
    },
    box: {
      height: "100%",
      width: 430,
      display: "flex",
      borderRadius: 4,
      boxShadow: "0 1px 1px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(32, 37, 43, 0.1)",
      backgroundColor: "white",
      padding: `58px 40px 24px`,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: "100%",
      height: "100%",
    },
    title: {
      fontSize: 18,
      lineHeight: 1.33,
      textAlign: "center",
      color: theme.palette.dark.main,
      marginBottom: theme.spacing(2),
      paddingTop: 58,
    },
    subtitle: {
      fontSize: 16,
      lineHeight: "normal",
      textAlign: "center",
      color: theme.palette.battleshipGrey.main,
    },
  }),
);
